<script setup>
import github from "@/assets/img/github.svg";
import google from "@/assets/img/google.svg";
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterSmall from "@/components/Footers/FooterSmall.vue";
import registerBg2 from "@/assets/img/register_bg_2.png";
import {ElLoading} from 'element-plus'
import {onMounted, ref, computed} from "vue";
//axios请求
import {inject} from 'vue'

const $axios = inject('$axios')
const rna_seqList = ref([])

function showRnaseq() {
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
    lock: true
  })
  $axios.get('http://bioinfo-gdut.com:8000/api/show_SraId').then((resp) => {
    if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
      rna_seqList.value = JSON.parse(JSON.stringify(resp.data))['list']
      loadingInstance.close()
    }
    goSearch.value = annotationType.value
  }).catch((err) => {
    loadingInstance.close()
    console.log(err)
  })
}

onMounted(() => {
  showRnaseq();
});
const link = computed(() => (item) => { //计算属性传递参数
  if (item[0] == 'S') {
    return "https://www.ncbi.nlm.nih.gov/sra/" + item
  } else {
    return "https://db.cngb.org/search/sample/" + item
  }
})
</script>

<template>
  <div>
    <navbar/>
    <main>
      <section class="relative w-full h-full py-40 min-h-screen">
        <div
            class="absolute top-0 w-full h-full bg-blueGray-800 bg-no-repeat bg-full"
            :style="`background-image: url('${registerBg2}');`"
        ></div>
        <div class="container mx-auto px-4 h-full">
          <div class="flex content-center items-center justify-center h-full">
            <div class="w-full lg:w-12/12 px-4">
              <div
                  class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
              >
                <div class="rounded-t mb-0 px-6 py-6">

                  <div class="text-center mt-3">
              <span class="text-blueGray-500 text-lg font-bold" style="font-size:35px">
                RNA-seq
               </span>
                  </div>
                  <div class="mt-1 py-10 border-t border-blueGray-200 text-center">
                    <div class="flex flex-wrap justify-center">
                      <div class="w-full lg:w-9/12 px-4">
                        <p class="mb-4 text-lg leading-relaxed text-blueGray-700">
                          This part is the IDs of each Lauraceae RNA-Seq downloaded from the public database, which can
                          be linked to the source data by clicking on the ID with the mouse.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <table class="table table-striped table-md align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 30%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 30%" class="pe-0 ps-0">Species</th>
                        <th scope="col" style="width: 40%" class="pe-0 ps-0">RNA-seq ID</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in rna_seqList">
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].species }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          <a class="link" :href="link(item['fields'].rna_seq_id)"
                             target="_blank">{{ item['fields'].rna_seq_id }}</a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer-small absolute/>
      </section>
    </main>
  </div>
</template>
<style>
.link:link {
  color: black;
}

.link:visited {
  color: black;
}

.link:hover {
  color: #e91e63;
}

</style>